// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';
export const plansTranslationsKo = {
  ...plansTranslationsEn,
  'plans.founder.remaining': 'Founder {count}자리 남음',
  'plans.founder.remaining_last': 'Founder 마지막 {count}자리',
  'plans.founder.remaining_limited': '한정: {count}자리 남음',
  'plans.founder.remaining_very_low': 'Founder {count}자리만 남음',
  'plans.founder.soldout': 'Founder 매진',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.compare.pro.adjustment_notice': '서비스 조건에 따라 가격이 조정될 수 있습니다.',
  'plans.compare.title': '요금제를 선택하세요',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150개 한정 자리',
  'plans.compare.cta.foundation': 'Founder 되기',
  'plans.compare.cta.pro': 'PRO로 업그레이드',
  'plans.compare.active': '현재 요금제',
  'plans.compare.limited': '',
  'plans.limit.title.messages': '메시지 한도 도달',
  'plans.limit.message.messages': '메시지 한도에 도달했습니다. FOUNDATION 또는 PRO로 업그레이드하세요.',
  'plans.limit.title.storage': '저장공간 한도 도달',
  'plans.limit.message.storage': '저장공간 한도에 도달했습니다. 더 많은 파일 업로드를 위해 업그레이드하세요.',
  'plans.limit.title.invitations': '초대 한도 도달',
  'plans.limit.message.invitations': '초대 한도에 도달했습니다. 더 많이 초대하려면 업그레이드하세요.',
  'plans.limit.reached': '한도 도달 — 요금제 업그레이드',
  'plans.compare.institucional.title': '제목',
  'plans.compare.yourPlan': '내 요금제',
  'plans.modal.title': '요금제 업그레이드',
  'plans.modal.comparison_title': '요금제 비교',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': '무료 요금제',
  'plans.free.features.contacts': '사용자당 최대 2명의 연락처',
  'plans.free.features.conversations': '계정당 최대 2개의 활성 대화',
  'plans.free.features.no_export': '계정당 월 3만 자; 일 34·월 1000메시지; 내보내기 없음',
  'plans.free.features.no_advanced': '파일·저장소 없음; 30일 기록; 사용자당 기기 1대',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founder 요금제',
  'plans.foundation.features.contacts': 'PRO와 동일한 프리미엄 계약(사용자당 최대 100명)',
  'plans.foundation.features.conversations': '무제한 채팅(테넌트); PRO와 동일 한도',
  'plans.foundation.features.badge': 'Founder 프로그램(번호가 매겨진 150석)',
  'plans.foundation.features.support': 'Founder석이 있을 때 월 USD 15',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Pro 요금제',
  'plans.pro.features.contacts': '사용자당 최대 100명의 연락처',
  'plans.pro.features.conversations': '무제한 채팅(테넌트); 일 1667·월 5만 메시지',
  'plans.pro.features.export': '최대 50MB(테넌트); 내보내기·자동 번역·파일은 요금제에 따름',
  'plans.pro.features.notifications': '사용자당 최대 3대 기기; 테넌트 초대 무제한',
  'plans.actions.free': '현재 요금제',
  'plans.actions.foundation': 'Founder 되기',
  'plans.actions.pro': 'PRO로 업그레이드',
  'plans.badges.recommended': '추천',
  'plans.badges.limited': '한정',
  'plans.badges.foundation': 'Founder',
  'plans.modal.free.line1': '계정당 월 30,000자.',
  'plans.modal.free.line2': '사용자당 최대 2명의 연락처.',
  'plans.modal.free.line3': '계정당 최대 2개의 활성 대화.',
  'plans.modal.free.line4': '첨부 파일이나 저장 공간 없음.',
  'plans.modal.free.line5': '데이터 내보내기 없음.',
  'plans.modal.free.line6': '메시지 기록 최대 30일.',
  'plans.modal.free.line7': '사용자당 기기 1대만.',
  'plans.modal.premium.line1': '계정당 월 300,000자.',
  'plans.modal.premium.line2': '사용자당 최대 100명의 연락처.',
  'plans.modal.premium.line3': '무제한 대화 및 채팅(테넌트).',
  'plans.modal.premium.line4': '최대 50MB 저장소(테넌트).',
  'plans.modal.premium.line5': '사용자당 최대 3대의 기기.',
  'plans.modal.premium.line6': '무제한 초대(테넌트).',
  'plans.modal.premium.line7': '요금제 한도 내 내보내기, 자동 번역, 파일 포함.',
  'plans.modal.premium_block_heading': '엔진 사용 한도(프리미엄)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder 프로그램',
  'plans.modal.foundation.categories_title': 'Founder 카테고리({slots}석)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': '순위 1–25',
  'plans.modal.foundation.cat_legendary_desc': '프로젝트를 가장 먼저 후원한 분들. 최고의 역사적 우선순위.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': '순위 26–75',
  'plans.modal.foundation.cat_early_desc': '특별한 인정이 있는 초기 후원.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': '순위 76–150',
  'plans.modal.foundation.cat_std_desc': '150석 내 Founder 자리.',
  'plans.modal.foundation.advantages_title': 'Founder 혜택',
  'plans.modal.foundation.adv1': '제한된 Founder 풀({slots}개 번호가 매겨진 자리)에 대한 액세스.',
  'plans.modal.foundation.adv2': 'ArChat 창립 사용자로서의 인정.',
  'plans.modal.foundation.adv3': '제품 경험에서의 Founder 배지와 존재감.',
  'plans.modal.foundation.adv4': '순위(1–150)에 따른 역사적 우선순위와 지위.',
  'plans.modal.foundation.adv5': '현재 정책이 적용되는 동안 Founder 액세스와 연결된 지속 혜택.',
  'plans.modal.pro.tagline': '표준 프리미엄 — Founder 구성요소 없음',
  'plans.payments_disabled.title': '구독',
  'plans.payments_disabled.message': '구독이 점진적으로 활성화되고 있습니다. 이용 가능한 플랜과 혜택을 확인할 수 있습니다.',
  'plans.payments_disabled.confirm': '확인',
};